import React, { useMemo, useEffect, useState } from "react";
import TableContainer from "../../components/Common/TableContainer";
import { useNavigate } from "react-router-dom";
//Import Breadcrumb
import Breadcrumbs from "../../components/Common/Breadcrumb";
import {
  Container,
  Input,
  Label,
  Modal,
  ModalBody,
  ModalFooter,
  ModalHeader,
} from "reactstrap";
import { Button } from "reactstrap";
import "react-toastify/dist/ReactToastify.css";
import { toast } from "react-toastify";
import { AvField, AvForm } from "availity-reactstrap-validation";
import {
  DeleteBedType,
  FetchBedTypes,
  UpdateBedType,
} from "../../apis/BedType";
import { AxiosError } from "axios";

const BedType = () => {
  const [BedTypes, setBedTypes] = useState([]);
  const [updateData, setUpdateData] = useState({
    bedTypeId: "",
    itemName: "",
    isChecked: true,
  });
  const [deleteData, setDeleteData] = useState({
    bedTypeId: "",
  });
  const [modal_standard, setModal_standard] = useState(false);
  const [modal_static, setModal_static] = useState(false);

  const tog_standard = () => setModal_standard((prev) => !prev);
  const tog_static = () => setModal_static((prev) => !prev);
  const navigate = useNavigate();

  const fetchBedTypes = async () => {
    const response = await FetchBedTypes();
    setBedTypes(response.bedTypes);
  };
  useEffect(() => {
    fetchBedTypes();
  }, []);

  const handleUpdate = async () => {
    try {
      const { bedTypeId, itemName, isChecked } = updateData;

      const updatedBedType = await UpdateBedType(
        bedTypeId,
        itemName,
        isChecked ? "enabled" : "disabled",
      );
      if (updatedBedType) {
        toast.success("Bed Type Updated Successfully");
        setModal_standard(false);
        fetchBedTypes();
        navigate("/bed-type");
      } else {
        toast.error("Bed Type Update Failed");
      }
    } catch (error) {
      if (error instanceof AxiosError) {
        toast.error(error.response.data.message);
      } else {
        toast.error("An unexpected error occurred. Please try again later.");
      }
    }
  };

  const handleDelete = async () => {
    try {
      const { bedTypeId } = deleteData;

      const response = await DeleteBedType(bedTypeId);

      if (response) {
        toast.success("Bed Type Deleted Successfully");
        setModal_static(false);
        fetchBedTypes();
        navigate("/bed-type");
      } else {
        toast.error("Bed Type Deletion Failed");
      }
    } catch (error) {
      if (error instanceof AxiosError) {
        toast.error(error.response.data.message);
      } else {
        toast.error("An unexpected error occurred. Please try again later.");
      }
    }
  };

  const columns = useMemo(
    () => [
      {
        Header: "English Item Name",
        accessor: "itemName.en",
      },
      {
        Header: "Arabic Item Name",
        accessor: "itemName.ar",
      },
      {
        Header: "Status",
        accessor: "status",
        Cell: ({ value }) => (value === "enabled" ? "Active" : "Inactive"),
      },
      {
        Header: "Created At",
        accessor: "createdAt",
        Cell: ({ value }) => new Date(value).toLocaleDateString(),
      },

      {
        Header: "Action",
        accessor: "actions",
        Cell: ({ row }) => (
          <div>
            <Button
              color="primary"
              className="btn-icon"
              onClick={() => handleEditClick(row.original)}
            >
              <i className="mdi mdi-pencil"></i>
            </Button>
            <Button
              color="danger"
              className="btn-icon"
              onClick={() => handleDeleteClick(row.original)}
            >
              <i className="mdi mdi-delete"></i>
            </Button>
          </div>
        ),
      },
    ],
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [],
  );

  const handleEditClick = (bedType) => {
    setUpdateData({
      bedTypeId: bedType._id,
      itemName: bedType.itemName,
      isChecked: bedType.status === "enabled",
    });
    tog_standard(); // Open the modal
  };

  const handleDeleteClick = (bedType) => {
    setDeleteData({
      bedTypeId: bedType._id,
    });
    tog_static(); // Open the modal
  };
  const breadcrumbItems = [
    { title: "Dashboard", link: "/" },
    { title: "Bed Type", link: "#" },
  ];

  return (
    <React.Fragment>
      <div className="page-content">
      <Container className="px-0" fluid>
        <Breadcrumbs title="DATA TABLES" breadcrumbItems={breadcrumbItems} />
        <div className="p-6 flex flex-col gap-6 ">
          <div
            style={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
            }}
          >
            <Button
              color="success"
              className="waves-effect waves-light me-1"
              onClick={() => navigate("/bed-type/add")}
            >
              Add Bed type
            </Button>
          </div>
          <TableContainer
            columns={columns || []}
            data={BedTypes || []}
            isPagination={false}
            // isGlobalFilter={false}
            iscustomPageSize={false}
            isBordered={false}
            customPageSize={10}
          />
        </div>

        {/* START: Modal EDIT  */}
        <Modal isOpen={modal_standard} toggle={tog_standard}>
          <ModalHeader toggle={() => setModal_standard(false)}>
            Modal Heading
          </ModalHeader>
          <ModalBody>
            <AvForm onValidSubmit={handleUpdate}>
              <div className="mb-3">
                <AvField
                  name="itemNameEn"
                  label="Bed Type Name In English"
                  placeholder="Type Something In English"
                  type="text"
                  errorMessage="Enter Name In English"
                  value={updateData.itemName.en}
                  validate={{ required: { value: true } }}
                  onChange={(e) =>
                    setUpdateData({
                      ...updateData,
                      itemName: {
                        en: e.target.value,
                        ar: updateData.itemName.ar,
                      },
                    })
                  }
                />
              </div>
              <div className="mb-3">
                <AvField
                  name="itemNameAr"
                  label="Bed Type Name In Arabic"
                  placeholder="Type Something In Arabic"
                  type="text"
                  errorMessage="Enter Name In Arabic"
                  value={updateData.itemName.ar}
                  validate={{ required: { value: true } }}
                  onChange={(e) =>
                    setUpdateData({
                      ...updateData,
                      itemName: {
                        en: updateData.itemName.en,
                        ar: e.target.value,
                      },
                    })
                  }
                />
              </div>
              <h4 className="card-title">Status</h4>
              <div className="form-check form-switch mb-3" dir="ltr">
                <Input
                  type="checkbox"
                  className="form-check-input"
                  checked={updateData.isChecked}
                  onChange={() =>
                    setUpdateData({
                      ...updateData,
                      isChecked: !updateData.isChecked,
                    })
                  }
                  id="customSwitch1"
                  defaultChecked
                />

                <Label className="form-check-label" htmlFor="customSwitch1">
                  {updateData.isChecked ? "Active" : "Inactive"}
                </Label>
              </div>
            </AvForm>
          </ModalBody>
          <ModalFooter>
            <Button
              type="button"
              onClick={tog_standard}
              color="light"
              className="waves-effect"
            >
              Close
            </Button>
            <Button
              type="button"
              onClick={handleUpdate}
              color="primary"
              className="waves-effect waves-light"
            >
              Save Changes
            </Button>
          </ModalFooter>
        </Modal>
        {/* END: Modal EDIT  */}

        {/* START: Modal DELETE */}

        <Modal isOpen={modal_static} toggle={tog_static} backdrop="static">
          <ModalHeader toggle={() => setModal_static(false)}>
            Static Backdrop
          </ModalHeader>
          <ModalBody>
            <p>Are you sure you want to delete this Bed type?</p>
            <ModalFooter>
              <Button type="button" color="light" onClick={tog_static}>
                Close
              </Button>
              <Button type="button" color="primary" onClick={handleDelete}>
                Save
              </Button>
            </ModalFooter>
          </ModalBody>
        </Modal>
        {/* END: Modal DELETE */}
      </Container>
      </div>
    </React.Fragment>
  );
};

export default BedType;
